import { Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { Presentation } from '../../model/PresentationTypes';
import classes from './PresentationCard.module.css';

export interface PresentationCardProps {
  presentation: Presentation;
  to?: string;
  onClick?: () => void;
}

export function PresentationCard({ presentation, to, onClick }: PresentationCardProps) {
  const { title, volumeName } = presentation;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      to={to}
      onClick={onClick}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="4px">
        <TitleCard title={title} />
        <Text size="sm">{volumeName}</Text>
      </Stack>
    </Paper>
  );
}
